import { MemberUsageTab } from "@/components/members/detail/member-usage-tab.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/settings/org/members/$userId/usage",
)({
	component: MemberUsageTab,
});
